export function findUniqueTags(obj) {
  const tags = [];
  const allTagsInString = obj
    .map((elem) => elem.tags)
    .join(' ')
    .replace(/[,]/g, ' ')
    .split(' ');
  return allTagsInString.filter((elem) =>
    elem !== '' ? (tags.includes(elem) ? null : tags.push(elem)) : null
  );
}

export function tagActivity(uniqueTags) {
  const tagActivity = uniqueTags.reduce((acc, elem) => {
    if (!acc[elem]) {
      acc[elem] = false;
    }
    return acc;
  }, {});
  return tagActivity;
}
